module.exports = __webpack_public_path__ + "static/media/spadesWhite.0b021be4.svg";